import Page from "../../components/Page";
import {Container, Grid} from "@material-ui/core";
import React from "react";
import UpgradeTable from "./UpgradeTable";
import CreateUpgradeButton from "./CreateUpgradeButton";
import {useCustomers} from "../../Auth";
import {HasRole} from "../../common/Util";
import {RoleIdEnum} from "../../generated/graphql";


export default () => {
    const customers = useCustomers();
    return (
        <Page title={"purchase order page"}>
            <Container maxWidth={false} style={{padding: "30px"}}>
                <Grid container spacing={2}>
                    <HasRole roles={[RoleIdEnum.Admin]}>
                        <CreateUpgradeButton customers={customers}/>
                    </HasRole>
                    <UpgradeTable/>
                </Grid>
            </Container>
        </Page>
    );
}